var render = function (_h,_vm) {var _c=_vm._c;return _c('svg',{staticClass:"tapered-rule",attrs:{"viewBox":"0 0 5 5","preserveAspectRatio":"none"}},[_c('polyline',{attrs:{"points":"0,0 5,2.5 0,5"}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5610890a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{"stripWithFunctional":true}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/tapered-rule.vue
// module id = null
// module chunks = 